import React from 'react'
import ColorPickerV2 from 'src/components/common/ColorPickerV2'
import { useCartContext } from 'src/lib/contexts/CartContext'

export const HeaderControl = () => {
  const {
    getters: { cartUIData },
    actions: { setCartUIConfigData }
  } = useCartContext()

  return (
    <div className='grid w-full gap-2 grid-cols-2'>
      <ColorPickerV2
        label='Background'
        color={cartUIData.header.backgroundColor}
        onChange={color => setCartUIConfigData({ backgroundColor: color }, 'HEADER')}
      />
      <ColorPickerV2
        label='Text'
        color={cartUIData.header.textColor}
        onChange={color => setCartUIConfigData({ textColor: color }, 'HEADER')}
      />
    </div>
  )
}
